/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Card,
  CardContent,
  CardDescription,
  Input,
  Badge,
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from "@repo/ui";
import Layout from "components/layout";
import { Link } from "react-router-dom";
import { useContext, useState } from "react";
import { useGetOrderLifeCycleBySeal } from "utils/apis/home.api";
import { process } from "@progress/kendo-data-query";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { UserContext } from "utils/reducers/user";
import { CircleX, View } from "lucide-react";
import { saveFilters } from "utils/actions/user";
import { getLink } from "utils/helper";

const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc"
    }
  ]
};

export default function PackageLifeCycle() {
  const user = useContext(UserContext);

  const [dataState, setDataState] = useState<any>(initialDataState);
  const [selectedItem, setSelectedItem] = useState<null | Record<
    string | number | symbol,
    any
  >>(null);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [filters, setFilters] = useState<any>(
    user?.filters?.["package-life-cycle"] || {}
  );

  const { data: allOrders } = useGetOrderLifeCycleBySeal(
    filters?.searchCriteria?.id.length >= 3 ? filters?.searchCriteria?.id : ""
  );

  const handleClearFilter = (key: string) => {
    const updatedFilter = { ...filters };
    delete updatedFilter[key];
    setFilters({ ...updatedFilter });
    saveFilters(user.dispatch, {
      ...user.filters,
      "package-life-cycle": updatedFilter
    });
  };

  const onDataStateChange = (e: any) => {
    setDataState(e.dataState);
  };

  const onFilterSearch = (e: any) => {
    setFilters({
      ...filters,
      searchCriteria: { name: e.target.value, id: e.target.value }
    });
    saveFilters(user.dispatch, {
      ...user.filters,
      "package-life-cycle": {
        ...filters,
        searchCriteria: { name: e.target.value, id: e.target.value }
      }
    });
  };

  function ShowOrderIDCell({ dataItem }: any) {
    const { requestId, jobNo, orderId, serviceType } = dataItem;

    return (
      <td>
        {serviceType ? (
          <Link
            to={getLink(serviceType)}
            state={{ requestId, jobNo, isReRoute: true }}
          >
            {orderId}
          </Link>
        ) : (
          orderId
        )}
      </td>
    );
  }

  function ActionCell({ dataItem }: any) {
    return (
      <td>
        <Button
          variant="link"
          onClick={() => {
            setSelectedItem(dataItem);
            setIsOpenModal(true);
          }}
        >
          <View />
        </Button>
      </td>
    );
  }

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Package Life Cycle</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <Card className="mt-3 mx-4">
        <CardContent>
          <CardDescription className="pt-6">
            <div className="flex mb-3 gap-3">
              <Input
                className="max-w-[420px] w-full"
                value={filters.searchCriteria?.id}
                onChange={onFilterSearch}
                placeholder="Package Seal No."
              />
            </div>
            <div className="flex gap-2 flex-wrap mb-3 items-center">
              {Object.entries(filters).map(([key, val]: any, i) =>
                val.id ? (
                  <Badge
                    variant="secondary"
                    className="gap-3 pr-1 cursor-pointer"
                    key={i}
                  >
                    {val?.name}{" "}
                    <CircleX
                      onClick={() => {
                        handleClearFilter(key);
                      }}
                    />
                  </Badge>
                ) : null
              )}
            </div>
            <div className="border-b mb-3 bg-accent" />
            <Grid
              className="text-xs"
              data={process(allOrders || [], {
                ...dataState,
                skip: 0
              })}
              {...dataState}
              onDataStateChange={onDataStateChange}
              sortable
              filterable
              size="small"
            >
              <Column
                field="orderId"
                title="Order Id"
                cell={ShowOrderIDCell}
                width={160}
              />
              <Column field="jobNo" title="Job No." width={100} />
              <Column field="actionDateTime" title="Date&Time" width={180} />
              <Column field="description" title="Description" />
              <Column field="routeNo" title="Route No." width={160} />
              <Column field="sourceLocation" title="Source Location" />
              <Column field="onwardLocation" title="Onward Location" />
              <Column cell={ActionCell} title="Action" width={70} />
            </Grid>
            <Dialog
              open={isOpenModal}
              onOpenChange={(val) => {
                setSelectedItem(null);
                setIsOpenModal(val);
              }}
            >
              <DialogContent className="max-w-[670px] w-full">
                <DialogHeader>
                  <DialogTitle>Package Detail View</DialogTitle>
                </DialogHeader>
                <DialogDescription className="pt-6">
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <div className="font-semibold">Order Id:</div>
                      <div>{selectedItem?.orderId}</div>
                    </div>
                    <div>
                      <div className="font-semibold">Job No:</div>
                      <div>{selectedItem?.jobNo}</div>
                    </div>
                    <div>
                      <div className="font-semibold">Date&Time:</div>
                      <div>{selectedItem?.actionDateTime}</div>
                    </div>
                    <div>
                      <div className="font-semibold">Route: No.</div>
                      <div>{selectedItem?.routeNo}</div>
                    </div>
                    <div>
                      <div className="font-semibold">Source:</div>
                      <div>{selectedItem?.sourceLocation}</div>
                    </div>
                    <div>
                      <div className="font-semibold">Onward:</div>
                      <div>{selectedItem?.onwardLocation}</div>
                    </div>
                    <div className="col-span-2">
                      <div className="font-semibold">Description:</div>
                      <div>{selectedItem?.description}</div>
                    </div>
                    <div className="col-span-2">
                      <div className="font-semibold">Remarks:</div>
                      <div>{selectedItem?.remarks}</div>
                    </div>
                  </div>
                </DialogDescription>
              </DialogContent>
            </Dialog>
          </CardDescription>
        </CardContent>
      </Card>
    </Layout>
  );
}
